module.exports = __webpack_public_path__ + "static/img/LC.8d00c9e0.svg";